import React from "react"

export default function EmptyPane({ text }) {
  const view = resolveEmptyPaneView(text)

  return (
    <div
      style={{
        padding: 16,
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)"
      }}
    >
      <div
        style={{
          borderRadius: 22,
          border: `1px solid ${view.border}`,
          background: view.background,
          boxShadow: "0 10px 24px rgba(15,23,42,0.05)",
          padding: 18,
          display: "grid",
          gap: 14,
          maxWidth: 760
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 14,
            minWidth: 0
          }}
        >
          <div
            style={{
              width: 42,
              height: 42,
              minWidth: 42,
              borderRadius: 15,
              background: view.iconBg,
              color: view.iconColor,
              border: `1px solid ${view.iconBorder}`,
              display: "grid",
              placeItems: "center",
              fontSize: 13,
              fontWeight: 950,
              boxShadow: view.iconShadow
            }}
          >
            {view.icon}
          </div>

          <div style={{ minWidth: 0, flex: 1 }}>
            <div
              style={{
                fontSize: 20,
                fontWeight: 950,
                lineHeight: 1.08,
                letterSpacing: "-0.03em",
                color: "#0f172a"
              }}
            >
              {view.title}
            </div>

            <div
              style={{
                marginTop: 5,
                fontSize: 13.5,
                lineHeight: 1.45,
                color: "#475569"
              }}
            >
              {view.text}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap"
          }}
        >
          {view.pills.map((pill) => (
            <span
              key={pill}
              style={{
                minHeight: 28,
                padding: "0 10px",
                borderRadius: 999,
                border: "1px solid #dbe3ef",
                background: "rgba(255,255,255,0.9)",
                color: "#334155",
                display: "inline-flex",
                alignItems: "center",
                fontSize: 12,
                fontWeight: 850
              }}
            >
              {pill}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

function resolveEmptyPaneView(text) {
  const raw = String(text || "").toLowerCase()

  if (raw.includes("clínica")) {
    return {
      icon: "CL",
      title: "Selecciona una clínica",
      text: "Elige una clínica activa para cargar su listado de pacientes y abrir el espacio de trabajo.",
      pills: ["Contexto requerido", "Listado", "Ficha del paciente"],
      background: "linear-gradient(180deg, #ffffff 0%, #eff6ff 100%)",
      border: "#bfdbfe",
      iconBg: "#dbeafe",
      iconColor: "#1d4ed8",
      iconBorder: "#bfdbfe",
      iconShadow: "0 10px 20px rgba(37,99,235,0.12)"
    }
  }

  if (raw.includes("cargando")) {
    return {
      icon: "···",
      title: "Cargando ficha",
      text: "Estamos preparando el resumen clínico, citas, odontograma, planes y finanzas del paciente.",
      pills: ["Resumen", "Citas", "Finanzas"],
      background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
      border: "#e2e8f0",
      iconBg: "#f8fafc",
      iconColor: "#334155",
      iconBorder: "#dbe3ef",
      iconShadow: "none"
    }
  }

  return {
    icon: "PA",
    title: "Elige un paciente del listado",
    text: "Al seleccionarlo verás su ficha, acciones rápidas, citas, odontograma, planes y estado financiero en este panel.",
    pills: ["Ficha", "Acciones", "Seguimiento"],
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    border: "#dbeafe",
    iconBg: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    iconColor: "#ffffff",
    iconBorder: "rgba(255,255,255,0.18)",
    iconShadow: "0 10px 20px rgba(37,99,235,0.18)"
  }
}
